import { formatDate } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { CubejsService } from 'app/shared/cubejs/cubejs.service';
import { ChartConfiguration } from 'chart.js';
import * as d3 from 'd3';
import moment from 'moment';
import { BaseChartDirective } from 'ng2-charts';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);

@Component({
  selector: 'app-monthly-importer-analytics',
  templateUrl: './monthly-importer-analytics.component.html',
  styleUrls: ['./monthly-importer-analytics.component.scss']
})
export class MonthlyImporterAnalyticsComponent implements OnInit {

  private svg: any;
  private projection: any;
  private path: any;
  hasComplianceFiltered: boolean = true;
  public chemicalsChartData = [];
  public chemicalsChartDataFiltered = [];
  hasDevelopmentOverTime: boolean = true;
  public developmentChartData = [];
  public developmentChartLabelsProcess = [];
  titleCompliance1: string;
  titleCompliance1Filtered: string;
  hasNotDataPerformanceDetails: boolean = false;
  performanceDetails: string[] = ['supplierName', 'country', 'chemicals', 'profile'];
  displayedColumnsVendors: string[] = ['vendors'];
  performanceDetailsDataList = new MatTableDataSource<any>();
  vendorsDataSource: any[] = [];
  @ViewChild(MatSort) performanceDetailsMatSort!: MatSort;
  @ViewChild(MatPaginator) performanceDetailsMatPaginator!: MatPaginator;
  mapHeight: number;
  importerName: string = '';
  startDate: string;
  endDate: string;
  originalStartDate: string;
  originalEndDate: string;
  startDateControl = new FormControl();
  endDateControl = new FormControl();
  countryFilter: any[];
  countryControl = new FormControl();
  allCountries: any[];
  selectedCountry = [];
  nameIDControl = new FormControl();
  @ViewChild('sideMenu') sideMenu!: ElementRef<HTMLDivElement>;
  @ViewChild('rightCard') rightCard!: ElementRef<HTMLDivElement>;
  filters: any[] = [];
  filters2: any[] = [];
  connectedFactories: number = 0;
  supplierMapData: any[] = []
  public chemicalsChartLabelsFiltered = [];
  public chartOptions: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: true,
        borderWidth: 1,
        callbacks: {
          label: function (context: any) {
            let label = context.dataset.label || '';

            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              const value = context.parsed.y;
              const formattedValue = value % 1 !== 0 ? value.toFixed(2) : value;
              label += formattedValue;
            }
            return label;
          }
        }
      },
      datalabels: {
        anchor: 'center',  // or 'end', 'start'
        align: 'center',   // position inside the bar
        color: 'black',    // font color
        font: {
          size: 12,
        },
        formatter: (value) => {
          // Hide datalabel if value is 0 or null
          return value ? value : '';
        }  // display the value itself
      },
      legend: {
        display: true,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      }
    },
    maintainAspectRatio: false,
    layout: { padding: 0 },
  };
  currentColumn: string = '';
  filterText: string = '';
  columnValues: string[] = [];
  filteredColumnValues: string[] = [];
  isLoadedMap: boolean = false;

  constructor(private cubejsService: CubejsService, private route: ActivatedRoute, private router: Router) {
    this.route.queryParams.subscribe(params => {
      this.importerName = params['importer'];
      this.startDate = params['startDate'];
      this.endDate = params['endDate'];
      this.originalStartDate = params['startDate'];
      this.originalEndDate = params['endDate'];
      this.vendorsDataSource = params['importersList']
      // this.allCountries = params['countryList']
      // this.allCountries = params['countryList']
      // this.countryFilter = this.allCountries
    });
  }
  ngOnInit(): void {
    this.isLoadedMap = true;
    const storedStart = localStorage.getItem('startDate');
    const storedEnd = localStorage.getItem('endDate');

    // ‼ Only proceed if both dates exist
    if (storedStart && storedEnd) {
      this.startDate = storedStart;
      this.endDate = storedEnd;
      this.startDateControl.setValue(new Date(storedStart));
      this.endDateControl.setValue(new Date(storedEnd));

      this.importerName = localStorage.getItem('importerName') ?? '';
      this.vendorsDataSource = JSON.parse(localStorage.getItem('importersList') ?? '[]');
      this.allCountries = JSON.parse(localStorage.getItem('countryList') ?? '[]');
      localStorage.removeItem('startDate');
      localStorage.removeItem('endDate');
      localStorage.removeItem('importerName');
      localStorage.removeItem('importersList');
      localStorage.removeItem('countryList');
    }
    else {
      this.startDateControl.setValue(new Date(this.startDate));
      this.endDateControl.setValue(new Date(this.endDate));
    }
    this.filters.push(
      {
        "member": "Dummy.date",
        "operator": "inDateRange",
        "values": [
          this.startDate,
          this.endDate]
      },
      {
        "member": "AldiNewReport.importer_name",
        "operator": "equals",
        "values": [
          this.importerName
        ]
      },
      {
        "member": "AldiNewReport.type_of_calc",
        "operator": "equals",
        "values": [
          "raw"
        ]
      }

    )
    this.filters2.push(
      {
        "member": "Dummy.date",
        "operator": "inDateRange",
        "values": [
          this.startDate,
          this.endDate]
      },
      {
        "member": "AldiNewReport.importer_name",
        "operator": "equals",
        "values": [
          this.importerName
        ]
      },
      {
        "member": "AldiNewReport.type_of_calc",
        "operator": "equals",
        "values": [
          "monthly"
        ]
      }

    )
    this.getCountryList();
    this.getNrFactories();
    this.getSupplierCountries();
    this.getChemicalCompliance();
    this.getPerformanceDetails();
    this.getDevelopmentOverTime();
  }



  getCountryList() {
    const query = {
      "dimensions": [
        "AldiNewReport.supplier_country"
      ],
      "filters": [{
        "member": "Dummy.date",
        "operator": "inDateRange",
        "values": [
          this.startDate,
          this.endDate]
      },
      {
        "member": "AldiNewReport.importer_name",
        "operator": "equals",
        "values": [
          this.importerName
        ]
      },
      {
        "member": "AldiNewReport.type_of_calc",
        "operator": "equals",
        "values": [
          "raw"
        ]
      }]
    }
    this.cubejsService.getCubeJSData(query, null, null, true, false)
      .then(data => {
        let tempData = data['loadResponse']['results'][0]['data'];
        if (tempData.length > 0) {
          tempData = this.changeKey("AldiNewReport.supplier_country", "supplier_country", tempData)
        }
        this.allCountries = Array.from(new Set(tempData.map(item => item.supplier_country)))
        this.countryFilter = this.allCountries
      })
  }

  //isLoadingnrFactories: boolean = false;
  getNrFactories() {
    const query = {
      "measures": [
        "AldiNewReport.supplier_count"
      ],
      "filters": this.filters

    }
    this.cubejsService.getCubeJSData(query, null, null, true, false)
      .then(data => {
        let tempData = data['loadResponse']['results'][0]['data'];
        if (tempData.length > 0) {
          tempData = this.changeKey("AldiNewReport.supplier_count", "supplier_count", tempData)
          tempData = this.changeKey("AldiNewReport.type_of_calc", "type_of_calc", tempData)
          this.connectedFactories = tempData[0]['supplier_count']
        }
      })

  }

  isLoadingSupplierCountries: boolean = false;
  getSupplierCountries() {
    this.isLoadingSupplierCountries = true;
    const query = {
      "filters": this.filters,
      "measures": [
        "AldiNewReport.supplier_count"
      ],
      "dimensions": [
        "AldiNewReport.supplier_country"
      ]
    }
    this.cubejsService.getCubeJSData(query, null, null, true, false)
      .then(data => {
        let tempData = data['loadResponse']['results'][0]['data'];
        if (tempData.length > 0) {
          tempData = this.changeKey("AldiNewReport.supplier_count", "supplier_count", tempData)
          tempData = this.changeKey("AldiNewReport.supplier_country", "supplier_country", tempData)
        }
        this.supplierMapData = tempData
        this.createWorldMapChart();
      })

  }

  isLoadingChemicalCompliance: boolean = false;
  getChemicalCompliance() {
    this.filters = this.filters.filter((el) => { return el['member'] !== "AldiNewReport.type_of_calc" })
    this.isLoadingChemicalCompliance = true;
    this.hasComplianceFiltered = true;
    this.chemicalsChartDataFiltered = []
    this.chartOptions!.scales = {
      x: {
        border: {
          display: false
        },
        stacked: true,
        grid: {
          display: false,
          drawTicks: false,
        },
      },
      y: {
        border: {
          display: false
        },
        stacked: true,
        grid: {
        },
      }
    }
    const query = {
      "filters": this.filters,
      "measures": [
        "AldiNewReport.low_compliance_supplier_count",
        "AldiNewReport.medium_compliance_supplier_count",
        "AldiNewReport.high_compliance_supplier_count"
      ]
    }
    this.cubejsService.getCubeJSData(query, null, null, true, false)
      .then(data => {
        let tempData = data['loadResponse']['results'][0]['data'];
        if (tempData.length > 0) {
          this.titleCompliance1 = tempData[0]['AldiNewReport.low_compliance_supplier_count'];
          this.chemicalsChartDataFiltered = [
            {
              label: '<60% compliance',
              backgroundColor: '#EC8484',
              borderColor: '#EC8484',
              hoverBackgroundColor: '#EC8484',
              data: [tempData[0]["AldiNewReport.low_compliance_supplier_count"]],
              yValue: [["AldiNewReport.low_compliance_supplier_count"]]
            },
            {
              label: '60-80% compliance',
              backgroundColor: '#FFD073',
              borderColor: '#FFD073',
              hoverBackgroundColor: '#FFD073',
              data: [tempData[0]["AldiNewReport.medium_compliance_supplier_count"]],
              yValue: [["AldiNewReport.medium_compliance_supplier_count"]]
            },
            {
              label: '>80% compliance',
              backgroundColor: '#ACE89C',
              borderColor: '#ACE89C',
              hoverBackgroundColor: '#ACE89C',
              data: [tempData[0]["AldiNewReport.high_compliance_supplier_count"]],
              yValue: [["AldiNewReport.high_compliance_supplier_count"]]
            }
          ];

          this.chemicalsChartLabelsFiltered = ['Suppliers'];
          if (this.chemicalsChartDataFiltered[0].data[0] != null || this.chemicalsChartDataFiltered[1].data[0] != null || this.chemicalsChartDataFiltered[2].data[0] != null) {
            this.hasComplianceFiltered = true;
          }
          else {
            this.hasComplianceFiltered = false;
          }
        }
        else {
          this.hasComplianceFiltered = false;
        }
        this.chartOptions.plugins.legend = {
          display: false,
        }
        this.isLoadingChemicalCompliance = false;
      })
      .catch(error => {
        this.isLoadingChemicalCompliance = false;
        this.hasComplianceFiltered = false;
        console.log(error)

      })

  }


  isLoadingPerformanceDetails: boolean = false;
  getPerformanceDetails() {
    this.isLoadingPerformanceDetails = true;
    this.filters.push(
      {
        "member": "AldiNewReport.type_of_calc",
        "operator": "equals",
        "values": [
          "raw"
        ]
      }
    )
    const query = {
      "timeDimensions": [
      ],
      "filters": this.filters
      ,
      "dimensions": [
        "AldiNewReport.supplier_id",
        "AldiNewReport.supplier_name",
        "AldiNewReport.supplier_country",
        "AldiNewReport.supplier_compliance"
      ]
    }
    this.cubejsService.getCubeJSData(query, null, null, true, false)
      .then(data => {
        let tempData = data['loadResponse']['results'][0]['data'];
        if (tempData.length > 0) {
          this.hasNotDataPerformanceDetails = false
          tempData = this.changeKey("AldiNewReport.supplier_id", "supplier_id", tempData)
          tempData = this.changeKey("AldiNewReport.supplier_name", "supplier_name", tempData)
          tempData = this.changeKey("AldiNewReport.supplier_country", "supplier_country", tempData)
          tempData = this.changeKey("AldiNewReport.supplier_compliance", "supplier_compliance", tempData)
        }
        else this.hasNotDataPerformanceDetails = false
        this.performanceDetailsDataList.data = tempData;
        this.performanceDetailsDataList.paginator = this.performanceDetailsMatPaginator;
        this.performanceDetailsDataList.sort = this.performanceDetailsMatSort;
        this.isLoadingPerformanceDetails = false;
      })

  }
  isLoadingDevelopmentOverTime: boolean = false;
  getDevelopmentOverTime() {
    this.isLoadingDevelopmentOverTime = true;
    this.hasDevelopmentOverTime = true;
    this.developmentChartData = [];

    this.chartOptions!.scales = {
      x: {
        border: { display: false },
        stacked: true,
        grid: { display: false, drawTicks: false },
      },
      y: {
        border: { display: false },
        stacked: true,
        grid: {},
      }
    };

    const query = {
      filters: this.filters2,
      dimensions: ["AldiNewReport.scan_month"],
      measures: [
        "AldiNewReport.monthly_low_compliance_supplier_count",
        "AldiNewReport.monthly_medium_compliance_supplier_count",
        "AldiNewReport.monthly_high_compliance_supplier_count"
      ]
    };

    this.cubejsService.getCubeJSData(query, null, null, true, false)
      .then(data => {
        let tempData = data['loadResponse']['results'][0]['data'];
        tempData = tempData.filter(item => item["AldiNewReport.scan_month"] !== null);

        if (tempData.length > 0) {
          this.developmentChartLabelsProcess = data.chartPivot()
            .filter((c: any) => c.x && c.x !== '∅')
            .map((c: any) => c.x);

          // Build the data series objects one by one
          const lowData = tempData.map(item => item["AldiNewReport.monthly_low_compliance_supplier_count"]);
          const mediumData = tempData.map(item => item["AldiNewReport.monthly_medium_compliance_supplier_count"]);
          const highData = tempData.map(item => item["AldiNewReport.monthly_high_compliance_supplier_count"]);

          this.developmentChartData = [
            {
              label: '<60% compliance',
              backgroundColor: '#EC8484',
              borderColor: '#EC8484',
              hoverBackgroundColor: '#EC8484',
              data: lowData,
              yValue: [["AldiNewReport.monthly_low_compliance_supplier_count"]]
            },
            {
              label: '60-80% compliance',
              backgroundColor: '#FFD073',
              borderColor: '#FFD073',
              hoverBackgroundColor: '#FFD073',
              data: mediumData,
              yValue: [["AldiNewReport.monthly_medium_compliance_supplier_count"]]
            },
            {
              label: '>80% compliance',
              backgroundColor: '#ACE89C',
              borderColor: '#ACE89C',
              hoverBackgroundColor: '#ACE89C',
              data: highData,
              yValue: [["AldiNewReport.monthly_high_compliance_supplier_count"]]
            }
          ];

          if (
            this.developmentChartData.some(item =>
              item.data.some(value => value !== 0)
            )
          ) {
            this.hasDevelopmentOverTime = true;
          } else {
            this.hasDevelopmentOverTime = false;
          }
        } else {
          this.hasDevelopmentOverTime = false;
        }

        this.isLoadingDevelopmentOverTime = false;
      })
      .catch(error => {
        this.isLoadingDevelopmentOverTime = false;
        this.hasDevelopmentOverTime = false;
        console.error(error);
      });
  }



  onImporterClick(vendor: string) {
    this.importerName = vendor;
    this.columnFilters = {};
    this.currentColumn = '';
    this.selectedValues = [];
    this.filterText = '';
    this.performanceDetailsDataList.filterPredicate = () => true;
    this.performanceDetailsDataList.filter = '';
    this.filters = this.filters.filter((el) => { return el['member'] !== "AldiNewReport.importer_name" })
    this.filters2 = this.filters2.filter((el) => { return el['member'] !== "AldiNewReport.importer_name" })
    this.filters.push(
      {
        "member": "AldiNewReport.importer_name",
        "operator": "equals",
        "values": [
          this.importerName
        ]
      })
    this.filters2.push(
      {
        "member": "AldiNewReport.importer_name",
        "operator": "equals",
        "values": [
          this.importerName
        ]
      })
    this.getCountryList();
    this.getNrFactories();
    this.getSupplierCountries();
    this.getChemicalCompliance();
    this.getPerformanceDetails();
    this.getDevelopmentOverTime();
  }

  createWorldMapChart() {
    this.isLoadingSupplierCountries = true;
    if (d3.select('#map-container').select('svg')) {
      d3.select('#map-container').select('svg').remove();
    }

    d3.json('../../assets/output.geojson').then((worldData: any) => {
      const data = this.supplierMapData;
      const tooltip = d3.select('#tooltip');

      const width = (window.innerWidth - 720) * 0.5;  // 50vw
      const height = (window.innerWidth - 620) * 0.3; // 20vw (based on width, not height)
      this.mapHeight = height;
      this.projection = d3.geoMercator()
        .center([60, 40])           // [longitude, latitude]
        .scale(170)                 // adjust for zoom level
        .translate([width / 2, height / 2]);
      this.path = d3.geoPath().projection(this.projection);

      this.svg = d3.select('#map-container')
        .append('svg')
        .attr('width', width)
        .attr('height', height)
        .style('margin', "10px 0")
        .style("background-color", "#F6F8FB")
        .style("border-radius", "10px")
        .style("box-shadow", "inset 0 0 5px #D3DBE5")
        .style("transition", "box-shadow 0.3s ease");

      const colorScale = d3.scaleLinear<string>()
        .domain([0, d3.max(data.map((i: any) => i.supplier_count))!])
        .range(['#D3DBE5', '#8ED0E3']);

      const path = this.path;
      const svg = this.svg;

      this.svg
        .selectAll('path')
        .data(worldData.features)
        .enter()
        .append('path')
        .attr('d', this.path)
        .attr('fill', (d: any) => {
          const countryId = d.properties.NAME.toUpperCase();;
          const found = data.find((el: any) => el.supplier_country === countryId);
          const value = found ? found.supplier_count : 0;
          return value > 0 ? colorScale(value) : '#D3DBE5';
        })
        .attr('stroke', '#ffffff')
        .attr('stroke-width', 0.5)
        .on('mouseover', function (event: any, d: any) {
          const countryId = d.properties.NAME.toUpperCase();;
          const centroid = path.centroid(d);
          const found = data.find((el: any) => el.supplier_country === countryId);
          d3.select(event.currentTarget).attr('fill', '#b5babf');

          if (found) {
            const html = `
            <div class="map-country-info-wrapper">
              <table class="table table-striped table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Country</th>
                    <th>Suppliers</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td >${found.supplier_country}</td>
                    <td >${found.supplier_count}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          `;
            const mapContainerRect = document.getElementById('map-container')?.getBoundingClientRect();
            const tooltipWidth = 100;
            const tooltipHeight = 50;
            if (mapContainerRect) {
              const tooltipLeft = Math.min(mapContainerRect.width - tooltipWidth, Math.max(0, centroid[0] - (tooltipWidth / 2))); // Center the tooltip horizontally and prevent overflow
              const tooltipTop = Math.min(mapContainerRect.height - tooltipHeight, Math.max(0, centroid[1] - tooltipHeight - 10)); // Position the tooltip above the supplier_country and prevent overflow
              tooltip.html(html)
                .style('visibility', 'visible')
                .style('left', (event.offsetX + 10) + 'px')
                .style('top', (event.offsetY + 10) + 'px');
            }
          }
        })
        .on('mouseout', function (event: any, d: any) {
          const countryId = d.properties.NAME.toUpperCase();;
          const found = data.find((el: any) => el.supplier_country === countryId);
          const value = found ? found.supplier_count : 0;
          const fillColor = value > 0 ? colorScale(value) : '#D3DBE5';
          d3.select(event.currentTarget).attr('fill', fillColor);
          tooltip.style('visibility', 'hidden');
        });
      if (!data.length) return;
      svg.selectAll('g.icon-group')
        .data(worldData.features.filter((d: any) => {
          const countryData = data.find((el: any) => el.supplier_country === d.properties.NAME.toUpperCase());
          return countryData && countryData.supplier_count > 0;
        }))
        .enter()
        .append('g')
        .attr('class', 'icon-group')
        .each(function (d: any, i: number, group: any) {
          const centroid = path.centroid(d);
          const found = data.find((el: any) => el.supplier_country === d.properties.NAME.toUpperCase());
          const value = found ? found.supplier_count : 0;

          d3.select(group[i])
            .append('image')
            .attr('xlink:href', '../../assets/location_on_FILL1_wght400_GRAD0_opsz24.svg')
            .attr('width', 25)
            .attr('height', 25)
            .attr('x', centroid[0] - 10)
            .attr('y', centroid[1] - 10)
            .style('pointer-events', 'none');

          const badge = d3.select(group[i])
            .append('g')
            .attr('class', 'badge');

          badge.append('circle')
            .attr('cx', centroid[0] + 7)
            .attr('cy', centroid[1] - 7)
            .attr('r', 10)
            .attr('fill', 'red');

          badge.append('text')
            .attr('x', centroid[0] + 7)
            .attr('y', centroid[1] - 7)
            .attr('text-anchor', 'middle')
            .attr('alignment-baseline', 'middle')
            .attr('font-size', '8px')
            .attr('fill', 'white')
            .text(value);
        });

      const zoom: any = d3.zoom()
        .scaleExtent([1, 8])
        .on('zoom', (event) => {
          svg.selectAll('path')
            .attr('transform', event.transform)
            .attr('stroke-width', 0.5 / event.transform.k);

          svg.selectAll('g.icon-group')
            .attr('transform', event.transform)
            .select('.badge')
            .attr('r', 10 / event.transform.k)
            .select('circle')
            .attr('font-size', `${event.transform.k}px`);
        });

      this.isLoadingSupplierCountries = false;
      this.isLoadedMap = false;
      this.svg.call(zoom);
    }).catch(err => {
      console.log('Error loading world data:', err);
    });
  }
  changeEndDate(event: MatDatepickerInputEvent<Date>) {
    if (event.value !== null) {
      let std = new Date(this.startDateControl.value);
      let edd = new Date(this.endDateControl.value);
      this.startDate = new Date(std.getFullYear(), std.getMonth(), std.getDate() + 1).toISOString().slice(0, 10);
      this.endDate = new Date(edd.getFullYear(), edd.getMonth(), edd.getDate() + 1).toISOString().slice(0, 10);
      this.filters = this.filters.filter((el) => { return el['member'] !== "Dummy.date" })
      this.filters2 = this.filters2.filter((el) => { return el['member'] !== "Dummy.date" })
      this.filters.push(
        {
          "member": "Dummy.date",
          "operator": "inDateRange",
          "values": [
            this.startDate,
            this.endDate]
        }
      )
      this.filters2.push(
        {
          "member": "Dummy.date",
          "operator": "inDateRange",
          "values": [
            this.startDate,
            this.endDate]
        }
      )
      this.columnFilters = {};
      this.currentColumn = '';
      this.selectedValues = [];
      this.filterText = '';
      this.performanceDetailsDataList.filterPredicate = () => true;
      this.performanceDetailsDataList.filter = '';
      this.getCountryList();
      this.getNrFactories();
      this.getSupplierCountries();
      this.getChemicalCompliance();
      this.getPerformanceDetails();
      this.getDevelopmentOverTime();
    }
  }

  onInputChange(event: any, type: string) {
    const searchInput = event.target.value.toLowerCase();
    switch (type) {
      case 'Country': {
        if (searchInput == "") {
          this.countryControl.setValue(this.selectedCountry, { emitEvent: false });
          this.countryFilter = this.allCountries;
        }
        else {
          this.countryFilter = this.allCountries.filter(({ name }) => {
            const prov = name.toLowerCase();
            return prov.includes(searchInput);
          });
        }
        break;
      }
    }
  }
  onOpenChange(searchInput: any, type: string) {
    searchInput.value = "";
    switch (type) {
      case 'Country': {
        this.countryFilter = this.allCountries;
        this.countryControl.setValue(this.selectedCountry, { emitEvent: false });
        break;
      }
    }
  }
  selection(event, type: string) {
    switch (type) {
      case 'Country': {
        if (event.isUserInput) {
          if (event.source._selected) {
            this.selectedCountry.push(event.source.value);
          }
          else {
            this.selectedCountry = this.selectedCountry.filter(el => { return el != event.source.value })
          }
        }
        break;
      }
    }
  }

  applyFilters() {
    this.filters = [];
    this.filters2 = [];
    this.columnFilters = {};
    this.currentColumn = '';
    this.selectedValues = [];
    this.filterText = '';
    this.performanceDetailsDataList.filterPredicate = () => true;
    this.performanceDetailsDataList.filter = '';
    this.filters.push(
      {
        "member": "Dummy.date",
        "operator": "inDateRange",
        "values": [
          this.startDate,
          this.endDate]
      },
      {
        "member": "AldiNewReport.importer_name",
        "operator": "equals",
        "values": [
          this.importerName
        ]
      },
      {
        "member": "AldiNewReport.type_of_calc",
        "operator": "equals",
        "values": [
          "raw"
        ]
      }
    )
    this.filters2.push(
      {
        "member": "Dummy.date",
        "operator": "inDateRange",
        "values": [
          this.startDate,
          this.endDate]
      },
      {
        "member": "AldiNewReport.importer_name",
        "operator": "equals",
        "values": [
          this.importerName
        ]
      },
      {
        "member": "AldiNewReport.type_of_calc",
        "operator": "equals",
        "values": [
          "monthly"
        ]
      }
    )
    if (this.nameIDControl.value != null && this.nameIDControl.value != "") {
      const inputValue = this.nameIDControl.value;

      if (inputValue != null && inputValue !== '') {
        const trimmedValue = inputValue.trim();
        const isNumeric = /^\d+$/.test(trimmedValue);

        if (isNumeric) {
          // Search by ID (e.g., master ID or chemical ID)
          this.filters.push({
            member: "AldiNewReport.supplier_id",  // or another field for ID
            operator: "equals",
            values: [trimmedValue]
          });
          this.filters2.push({
            member: "AldiNewReport.supplier_id",  // or another field for ID
            operator: "equals",
            values: [trimmedValue]
          });
        } else {
          // Search by name
          this.filters.push({
            member: "AldiNewReport.supplier_name",
            operator: "contains",
            values: [trimmedValue]
          });
          this.filters2.push({
            member: "AldiNewReport.supplier_name",
            operator: "contains",
            values: [trimmedValue]
          });
        }
      }
    }

    if (this.countryControl.value && this.countryControl.value.length !== 0) {
      this.filters.push(
        {
          "member": "AldiNewReport.supplier_country",
          "operator": "equals",
          "values": this.countryControl.value
        }
      )
      this.filters2.push(
        {
          "member": "AldiNewReport.supplier_country",
          "operator": "equals",
          "values": this.countryControl.value
        }
      )
    }
    this.getNrFactories()
    this.getSupplierCountries();
    this.getChemicalCompliance();
    this.getPerformanceDetails();
    this.getDevelopmentOverTime();


  }

  clearFilter() {
    this.filters = [];
    this.filters2 = [];
    this.columnFilters = {};
    this.currentColumn = '';
    this.selectedValues = [];
    this.filterText = '';
    this.performanceDetailsDataList.filterPredicate = () => true;
    this.performanceDetailsDataList.filter = '';
    this.countryControl.reset();
    if (this.originalStartDate) {
      this.startDateControl.setValue(new Date(this.originalStartDate));
    }

    if (this.originalEndDate) {
      this.endDateControl.setValue(new Date(this.originalEndDate));
    }
    this.nameIDControl.reset();
    this.selectedCountry = [];
    this.filters.push(
      {
        "member": "Dummy.date",
        "operator": "inDateRange",
        "values": [
          this.originalStartDate,
          this.originalEndDate]
      },
      {
        "member": "AldiNewReport.importer_name",
        "operator": "equals",
        "values": [
          this.importerName
        ]
      },
      {
        "member": "AldiNewReport.type_of_calc",
        "operator": "equals",
        "values": [
          "raw"
        ]
      }
    )
    this.filters2.push(
      {
        "member": "Dummy.date",
        "operator": "inDateRange",
        "values": [
          this.originalStartDate,
          this.originalEndDate]
      },
      {
        "member": "AldiNewReport.importer_name",
        "operator": "equals",
        "values": [
          this.importerName
        ]
      },
      {
        "member": "AldiNewReport.type_of_calc",
        "operator": "equals",
        "values": [
          "monthly"
        ]
      }
    )
    this.getCountryList();
    this.getNrFactories();
    this.getSupplierCountries();
    this.getChemicalCompliance();
    this.getPerformanceDetails();
    this.getDevelopmentOverTime();

  }
  changeKey(originalKey: string, newKey: string, arr: Array<Object>) {
    var newArr = [];
    for (var i = 0; i < arr.length; i++) {
      var obj = arr[i];
      obj[newKey] = (newKey == "value" && obj[originalKey] === null) ? 0 : obj[originalKey];
      delete (obj[originalKey]);
      newArr.push(obj);
    }
    return newArr;
  }

  viewProfile(supplier_name: string) {
    localStorage.setItem('startDate', this.startDate);
    localStorage.setItem('endDate', this.endDate);
    localStorage.setItem('importerName', this.importerName);
    localStorage.setItem('importersList', JSON.stringify(this.vendorsDataSource));
    localStorage.setItem('countryList', JSON.stringify(this.allCountries));

    this.router.navigate(['brand-login/my-supplier'], {
      state: { supplier_name: supplier_name }
    });
  }

  selectedValues: string[] = [];

  columnFilters: { [key: string]: string[] } = {};

  openColumnFilterMenu(column: string) {
    this.currentColumn = column;
    this.filterText = '';

    const allValues = this.performanceDetailsDataList.filteredData
      .map(r => r[column]);
    const uniqueValues = Array.from(new Set(allValues.filter(v => v != null)));

    // special display mapping you already had …
    this.columnValues = uniqueValues.map(v => {
      if (column === 'sdsIssueDate' || column === 'updatedDate') {
        return formatDate(new Date(v), 'yyyy-MM-dd', 'en-US');
      }
      if (column === 'status') {
        return (v === false || v === 'false') ? 'Discontinued' : 'Active';
      }
      return v;
    }).sort();

    this.filteredColumnValues = [...this.columnValues];

    /* restore previous selections when the user re‑opens the menu */
    this.selectedValues = this.columnFilters[column] ?? [];
  }

  applyMultiColumnFilter() {
    this.columnFilters[this.currentColumn] = [...this.selectedValues];
    this.commitFilters();
  }

  applyColumnFilter(val: string) {
    this.columnFilters[this.currentColumn] = val ? [val] : [];
    this.commitFilters();
  }

  private commitFilters() {
    this.performanceDetailsDataList.filterPredicate = (row, jsonFilter) => {
      const filters = JSON.parse(jsonFilter) as { [key: string]: string[] };
      /* go through each active column filter */
      for (const col of Object.keys(filters)) {
        const wanted = filters[col];
        if (wanted.length === 0) continue;                    // nothing set
        if (!wanted.includes(row[col])) return false; // exclude row
      }
      return true;                                            // row passes
    };
    this.performanceDetailsDataList.filter = JSON.stringify(this.columnFilters);
  }

  clearColumnFilter() {
    this.columnFilters[this.currentColumn] = [];
    this.selectedValues = [];
    this.commitFilters();
  }
  updateFilteredColumnValues() {
    if (!this.filterText) {
      this.filteredColumnValues = [...this.columnValues];
    } else {
      const lowerFilter = this.filterText.toLowerCase();
      this.filteredColumnValues = this.columnValues.filter(val =>
        val.toString().toLowerCase().includes(lowerFilter)
      );
    }

    if (this.currentColumn === 'supplier_name') {
      const missingSelections = this.selectedValues.filter(val =>
        !this.filteredColumnValues.includes(val)
      );
      this.filteredColumnValues.push(...missingSelections);
    }
  }





}
